import { render, staticRenderFns } from "./DbcdR_Search.vue?vue&type=template&id=44f10066"
import script from "./DbcdR_Search.vue?vue&type=script&lang=js"
export * from "./DbcdR_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports